import {
  addPageSchema,
  generateSchemaForFinCen,
} from "./advancedSchemas";

function upsertSchemaScript(scriptId, schemaInfo) {
  if (!schemaInfo) return;

  let script = document.getElementById(scriptId);

  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = scriptId;
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(schemaInfo, null, 2);
}

async function applySupplementalSchemas() {
  const url = window.location.href;

  const supplementalGenerators = [
    {
      id: "legacy-aem-fincen-schema",
      run: () =>
        url.endsWith("/en/fincen-aml") ? generateSchemaForFinCen() : null,
    },
  ];

  for (const schemaGenerator of supplementalGenerators) {
    const result = await schemaGenerator.run();

    if (result) {
      upsertSchemaScript(schemaGenerator.id, result);
    }
  }
}

async function initAEMScriptBridge() {
  const main = document.querySelector("main");
  if (!main) return;

  const isSchemaEnabled = main.dataset.enableAemSchema === "true";
  if (!isSchemaEnabled) return;

  await addPageSchema();
  await applySupplementalSchemas();
}

export default initAEMScriptBridge;
